<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Fuel Stations",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data: () => {
         return {
            isloaded: false,
            title: "Fuel Stations",
            items: [
               {
                  text: "Fuel Stations",
                  active: true,
               },                   
            ],

            fuel_stations: [],

            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,
            fuel_station_status: {
               id: "",
               status: "",
            },
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
         // document.onreadystatechange = () => {
         //    if (document.readyState == "complete") { 
         //       this.isloaded = true;
         //    } 
         // }
    
      },

      created() {
         this.fetchFuelStations();
      },

      methods: {

         fetchFuelStations(page_url = null) {

            this.getToken();
            let url = "api/admin/fuelStation/index?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.isloaded = false;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.fuel_stations = responseData.fuel_stations.data;
                     
                     this.pagination = responseData.fuel_stations.links;
                     this.from = responseData.fuel_stations.from;
                     this.to = responseData.fuel_stations.to;
                     this.total = responseData.fuel_stations.total;
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.isloaded = true));
         }, 

         getToken() {
            if (localStorage.getItem('sigofuel_admin')) {
               var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
               if(sigofuel_admin.token) {
                  this.token = sigofuel_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         activateFuelStation(fuel_station) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this fuel station?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.fuel_station_status.id = fuel_station.fuel_station_id;
                  this.fuel_station_status.status = 1;
                  this.updateFuelStationStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateFuelStation(fuel_station) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this fuel station?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.fuel_station_status.id = fuel_station.fuel_station_id;
                  this.fuel_station_status.status = 2;
                  this.updateFuelStationStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateFuelStationStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/fuelStation/status?id=" + this.fuel_station_status.id + "&status=" + this.fuel_station_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchFuelStations(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template> 
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="page-loader" v-if="!isloaded">
            <img src="@/assets/images/preloaderspin.gif"/>
         </div>
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  
                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'stations.add' }" class="btn btn-primary float-end">Add Station</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchFuelStations()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchFuelStations()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchFuelStations()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>ID</th>
                              <th>Name (English)</th>              
                              <th>Name (Somali)</th>              
                              <th>Contact</th>
                              <!-- <th>Latitude</th>  
                              <th>Longitude</th>   -->
                              <th>Trucks</th>  
                              <th>Orders</th>
                              <th>Deposit Balance</th>                              
                              <th>Status</th>         
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(fuel_stations.length)">
                           <tr v-for="(station) in fuel_stations" :key="station.fuel_station_id">
                              <td>#{{station.fuel_station_id}}</td>
                              <td>{{station.name_en}}</td>
                              <td>{{station.name_so}}</td>
                              <td>
                                 {{station.country_code}} {{station.mobile}}<br>
                                 {{station.email}}
                              </td>
                              <!-- <td>25.2048493</td>
                              <td>55.2707828</td> -->
                              <td>{{station.truckcount}}</td>
                              <td>{{station.ordercount}}</td>
                              <td><span v-if="station.balance">${{station.balance}}</span></td>
                              <td>
                                 <span v-if="station.status == 1" class="badge rounded-pill bg-success">Active</span>
                                 <span v-if="station.status == 2" class="badge rounded-pill bg-danger">Blocked</span>
                              </td>
                              <td><p class="w-100px">{{station.converted_created_at}}</p></td>
                             
                              <td>
                                 <div class="w-200px">
                                    <router-link :to="{ name: 'stations.details', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                    <router-link :to="{ name: 'stations.edit', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Edit</router-link>

                                    <router-link :to="{ name: 'stations.fuels', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Fuels</router-link>

                                    <router-link :to="{ name: 'stations.orders', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Orders</router-link>  
                                        
                                    <router-link :to="{ name: 'stations.trucks', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Trucks</router-link> 

                                    <router-link :to="{ name: 'stations.drivers', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Drivers</router-link>                                      

                                    <router-link :to="{ name: 'stations.paymentlogs', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Payment Logs</router-link>

                                    <router-link :to="{ name: 'stations.earninglogs', params: {id: station.fuel_station_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Earning Logs</router-link>

                                    <b-button v-if="station.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateFuelStation(station)">Unpublish</b-button>

                                    <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateFuelStation(station)">Publish</b-button>
                                 </div>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="10" class="text-center">No fuel stations found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(fuel_stations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchFuelStations(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>


      
   </Layout>
</template>


<style lang="scss" scoped>
   // $colors: #8CC271, #69BEEB, #F5AA39, #E9643B;
  
  .page-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #f8f8fb;
    z-index: 999;
  }

  .page-loader img {
   max-width: 50px;
  }
  
//   .cube{
//     width: 40px;
//     height: 40px;
//     margin-right: 10px;
//     @for $i from 1 through length($colors) {
//       &:nth-child(#{$i}) {
//         background-color: nth($colors, $i);
//       }
//     }
//     &:first-child {
//       animation: left 1s infinite;
//     }
//     &:last-child {
//       animation: right 1s infinite .5s;
//     }
//   }
  
//   @keyframes left {
//     40% {
//       transform: translateX(-60px);
//     }
//     50% {
//       transform: translateX(0);      
//     }
//   }
//   @keyframes right {
//     40% {
//       transform: translateX(60px);
//     }
//     50% {
//       transform: translateX(0);
//     }
//   }
</style>

